module.exports = __webpack_public_path__ + "img/hotdog-top-image001.9cc950dd.jpg";